import React from 'react';
import { navigateToChangeInsightDetails } from '../../links/index.jsx';
import EmployeesFilter from './EmployeesFilter.jsx';
import GroupsFilter from './GroupsFilter.jsx';
import ResponseStatusFilter from './ResponseStatusFilter.jsx';
import StakeholdersGroupFilter from './StakeholdersGroupFilter.jsx';
import Filters from '../../filters/index.jsx';
import { SurveyIcon } from '../../icons/SurveyIcon.jsx';
import { ParticipantsIcon } from '../../icons/ParticipantsIcon.jsx';
import { resetFilters } from '../utils/index.js';

const CIStudioFilters = ({
  query,
  employees,
  groups,
  organizationStakeholders,
  initiativeId,
  initiativeType,
}) => {
  const filtersData = [
    {
      key: 'feedback-form',
      title: 'Feedback Form',
      icon: <SurveyIcon />,
      filters: [
        {
          key: 'response-status',
          title: 'Response Status',
          component: (
            <ResponseStatusFilter
              paramKey="statuses"
              navigateAction={(q) =>
                navigateToChangeInsightDetails(q, initiativeId, initiativeType)
              }
              selectedStatusesIds={query.statuses}
            />
          ),
        },
      ],
    },
    {
      key: 'participants',
      title: 'Participants',
      icon: <ParticipantsIcon />,
      filters: [
        {
          key: 'employee',
          title: 'Employee',
          component: (
            <EmployeesFilter
              selectedEmployeeIdsIds={query.employeeIds}
              initiativeParticipations={employees}
              initiativeId={initiativeId}
              initiativeType={initiativeType}
            />
          ),
        },
        {
          key: 'group',
          title: 'Group',
          resetQueryParams: { groupIds: [] },
          component: (
            <GroupsFilter
              selectedGroupIds={query.groupIds}
              groups={groups}
              initiativeId={initiativeId}
              initiativeType={initiativeType}
            />
          ),
        },
        {
          key: 'org-stakeholder',
          title: 'Stakeholder Group / Individual',
          resetQueryParams: { organizationStakeholderIds: [] },
          component: (
            <StakeholdersGroupFilter
              selectedInitiativeStakeholderIds={
                query.organizationStakeholderIds
              }
              initiativeStakeholders={organizationStakeholders}
              initiativeId={initiativeId}
              initiativeType={initiativeType}
            />
          ),
        },
      ],
    },
  ];

  return (
    <Filters
      filtersData={filtersData}
      query={query}
      resetAction={(q) =>
        navigateToChangeInsightDetails(q, initiativeId, initiativeType)
      }
      resetAllAction={() => resetFilters(initiativeId, initiativeType)}
      resetDependencies={[]}
    />
  );
};

export default CIStudioFilters;
